document.writeln('<link rel="stylesheet" type="text/css" href="/libs/vendor/jquery/jpicker-1.1.6/css/jPicker-1.1.6.min.css" media="screen" />');

$(function() {
  var els = jQuery(".input-colorpicker");
  els.attr({"readonly": "readonly"});
  els.jPicker({
    'window': {
      'position': {
        'x': 'screenCenter',
        'y': 'center'
      },
      'updateInputColor': false      
    },
    'images': {
      'clientPath': '/libs/vendor/jquery/jpicker-1.1.6/images/'
    }
  });
});